import { yup } from "@l2r-front/l2r-utils"

export const validationSchema = () => yup.object().shape({
    delivery_action: yup.string().required(),
    tags_to_add: yup.array(yup.string()),
    tags_to_delete: yup.array(yup.string()),
})